import Brand from '../../common/Brand';
import LanguageSwitcher from '../../common/LanguageSwitcher';
import FooterColumnLinks from './FooterColumnLinks';
import FooterSocialLinks from './FooterSocialLinks';
import type { FooterProps } from './useFooter';

const FooterDesktop = ({ data, handleServiceClick }: FooterProps) => {
  return (
    <footer
      className="bg-surface-inverse"
      style={{ padding: '80px 80px 40px 80px' }}
    >
      <div className="flex flex-col gap-15">
        <div className="flex justify-between">
          <div className="flex w-80 flex-col gap-6">
            <Brand link="/" variant="light" />
            <p
              className="font-body text-[15px] leading-[1.6]"
              style={{ color: 'rgba(255, 255, 255, 0.6)' }}
            >
              {data.tagline}
            </p>
            <LanguageSwitcher variant="light" className="w-fit" />
          </div>

          <div className="flex gap-20">
            {data.columns.map((column) => (
              <FooterColumnLinks
                key={column.title}
                column={column}
                handleServiceClick={handleServiceClick}
              />
            ))}
          </div>
        </div>

        <div
          className="h-px w-full"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.125)' }}
        />

        <div className="flex items-center justify-between">
          <p
            className="font-body text-sm"
            style={{ color: 'rgba(255, 255, 255, 0.7)' }}
          >
            {data.copyright}
          </p>
          <FooterSocialLinks />
        </div>
      </div>
    </footer>
  );
};

export default FooterDesktop;
